<template>
  <div class="main">
    <div class="main_header">
      <!-- <div class="header_item">
        <span class="header_label">类型：</span>
        <el-select v-model="search.dictType" placeholder="请选择类型" clearable>
            <el-option
            v-for="item in optionsType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
      </div> -->
      <div class="header_item">
        <span class="header_label">项目名称：</span>
        <el-input v-model="search.chainProjectName" :size="size" clearable placeholder="请输入项目名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">建设单位：</span>
        <el-input v-model="search.constructionUnit" :size="size" clearable placeholder="请输入建设单位"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">设计单位：</span>
        <el-input v-model="search.designUnit" :size="size" clearable placeholder="请输入设计单位"></el-input>
      </div>
      <div class="header_item">
        <el-button   :size="size" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
        <!-- <el-button icon="el-icon-upload2" v-if="showButton('export')" @click="exportBigData">导出Excel</el-button> -->
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="chainProjectName" label="项目名称" align="center" ></el-table-column>
        <el-table-column prop="chainProjectIntroduction" show-overflow-tooltip label="项目简介" align="center" ></el-table-column>
        <el-table-column  label="尺寸" prop="sizeName" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="constructionPeriod" label="工期（月）" min-width="100" align="center" ></el-table-column>
        <el-table-column prop="startTime" label="开始日期" align="center"></el-table-column>
        <el-table-column prop="demand" label="需求量" align="center"></el-table-column>
        <el-table-column prop="chainLength" label="长度" align="center"></el-table-column>
        <el-table-column prop="chainWidth" label="宽度" align="center"></el-table-column>
        <el-table-column prop="chainThickness" label="厚度" align="center"></el-table-column>
        <el-table-column prop="concreteGrade" label="混凝土等级" align="center"></el-table-column>
        <el-table-column prop="impermeabilityGrade" label="抗渗等级" align="center"></el-table-column>
        <el-table-column prop="antifreezeGrade" label="抗冻等级" align="center"></el-table-column>
        <el-table-column prop="constructionUnit" label="建设单位" align="center" ></el-table-column>
        <el-table-column prop="supervisionUnit" label="监理单位" align="center" ></el-table-column>
        <el-table-column prop="workUnit" label="施工单位" align="center" ></el-table-column>
        <el-table-column prop="designUnit" label="设计单位" align="center" ></el-table-column>
        <el-table-column label="操作" align="center" min-width="120">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增项目' : '修改项目'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="项目名称：" prop="chainProjectName">
          <el-input v-model="ruleForm.chainProjectName" :size="size" clearable placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="项目简介：" prop="chainProjectIntroduction">
          <el-input v-model="ruleForm.chainProjectIntroduction" :size="size" type="textarea" :rows="3" clearable placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="尺寸：" prop="sizes">
          <el-select v-model="ruleForm.sizes" placeholder="请选择尺寸">
                <el-option
                v-for="item in optionsSize"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="开始日期：" prop="startTime">
          <el-date-picker
                v-model="ruleForm.startTime"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
                placeholder="请选择开始日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="工期(月)：" prop="constructionPeriod">
          <el-input v-model="ruleForm.constructionPeriod" :size="size" type="number" clearable placeholder="请输入工期"></el-input>
        </el-form-item>
        <el-form-item label="需求量：" prop="demand">
          <el-input v-model="ruleForm.demand" :size="size" type="number" clearable placeholder="请输入需求量"></el-input>
        </el-form-item>
        <el-form-item label="长度：" prop="chainLength">
          <el-input v-model="ruleForm.chainLength" :size="size" type="number" clearable placeholder="请输入长度"></el-input>
        </el-form-item>
        <el-form-item label="宽度：" prop="chainWidth">
          <el-input v-model="ruleForm.chainWidth" :size="size" type="number" clearable placeholder="请输入宽度"></el-input>
        </el-form-item>
        <el-form-item label="厚度：" prop="chainThickness">
          <el-input v-model="ruleForm.chainThickness" :size="size" type="number" clearable placeholder="请输入厚度"></el-input>
        </el-form-item>
        <el-form-item label="混凝土等级：" prop="concreteGrade">
          <el-input v-model="ruleForm.concreteGrade" :size="size" clearable placeholder="请输入混凝土等级"></el-input>
        </el-form-item>
        <el-form-item label="抗渗等级：" prop="impermeabilityGrade">
          <el-input v-model="ruleForm.impermeabilityGrade" :size="size"  clearable placeholder="请输入抗渗等级"></el-input>
        </el-form-item>
        <el-form-item label="抗冻等级：" prop="antifreezeGrade">
          <el-input v-model="ruleForm.antifreezeGrade" :size="size" clearable placeholder="请输入抗冻等级"></el-input>
        </el-form-item>
        <el-form-item label="建设单位：" prop="constructionUnit">
          <el-input v-model="ruleForm.constructionUnit" :size="size" clearable placeholder="请输入建设单位"></el-input>
        </el-form-item>
        <el-form-item label="监理单位：" prop="supervisionUnit">
          <el-input v-model="ruleForm.supervisionUnit" :size="size"  clearable placeholder="请输入监理单位"></el-input>
        </el-form-item>
        <el-form-item label="施工单位：" prop="workUnit">
          <el-input v-model="ruleForm.workUnit" :size="size"  clearable placeholder="请输入施工单位"></el-input>
        </el-form-item>
        <el-form-item label="设计单位：" prop="designUnit">
          <el-input v-model="ruleForm.designUnit" :size="size"  clearable placeholder="请输入设计单位"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize, downFiles } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //连锁块管理列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        rowId:'', // 项目id
        ruleForm: {
        }, // 按钮表单
        rules: {
          chainProjectName: [{
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }],
          chainProjectIntroduction: [{
            required: true,
            message: '请输入项目简介',
            trigger: 'blur'
          }],
          sizes: [{
            required: true,
            message: '请选择尺寸',
            trigger: 'blur'
          }],
          constructionPeriod: [{
            required: true,
            message: '请输入工期',
            trigger: 'blur'
          }],
          
        },
        optionsSize:[],//尺寸下拉框
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs['ruleForm'].resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()//获取尺寸配筋等信息
    },
    methods: {
      //table上展示尺寸等信息
      showInfo(val){
        let str=''
        let str1 = ''
        if(val.length===1){
            str = val[0].dictName
        }else{
            val.forEach(item=>{
                str+=item.dictName+','
            })
            str1 = str.lastIndexOf(',')
            str = str.substring(0,str1)
        }
        return str
      },
      //获取尺寸配筋转向等信息
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsSize = res.data.list.filter(item =>item.dictType === 'chain_size_type')
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },

      // 转圈圈
    functionLoading() {
        this.loadingView = this.$loading({
            lock: true,
            text: '请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    //导出Excel
    exportBigData(){
        this.functionLoading();
        let params  = Object.assign({},this.search)
        this.$api.Chain.exportChainProjectDatas(params).then(res => {
            downFiles(res, '连锁块项目管理信息', 'xls')
            this.loadingView.close()
        })
        .catch(() => {
          this.loadingView.close();
        })
    },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Chain.searchChainProjectList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.rowId = row.chainProjectId
        this.$api.Chain.detailsChainProject({chainProjectId: row.chainProjectId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Chain.deleteChainProject({chainProjectId: row.chainProjectId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.Chain.insertChainProjectOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.chainProjectId = this.rowId
            this.$api.Chain.insertChainProjectOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>